
const fields = [
  {
    type: 'bsx-label',
    label: 'ID',
    model: 'id',
    visible: (model) => model.id,
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '科別名稱',
    model: 'name',
    placeholder: '科別名稱',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '科別說明',
    model: 'intro',
    placeholder: '科別說明',
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-select',
    label: 'Icon Code',
    model: 'icon_code',
    help: 'Icon 對照表請參考 禾馨醫療 | 院所清單調查表',
    required: true,
    values: [
      'OBGYN', 'PED', 'PEDS', 'CV', 'FER', 'DERM', 'HEMA', 'VS', 'AESMED', 'PSY',
      'BS', 'PT', 'UR', 'RS', 'NEURO', 'AIR', 'GE', 'LAC', 'OPH', 'METALW', 'PMR',
      'GBC', 'META', 'PM', 'DEN', 'ORTHO', 'DNATEST'
    ],
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-input",
    inputType: "number",
    label: "排序權重",
    hint: "權重數字越大，排序越前；若數字相同，則 ID 越大，排序越前",
    model: "weight",
    placeholder: "排序權重",
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-toggle',
    label: '狀態',
    model: 'status',
    required: true,
    textOn: '上架',
    textOff: '下架',
    valueOn: 'ON',
    valueOff: 'OFF',
  },
];

export default fields;
